/**
 * Мобильный тренажёр: плотнее типографика (~+15% материала по высоте).
 * 14px / line-height 1.5 против типичных 16px / 1.5 даёт ~12.5% меньше высоты строки;
 * вместе с чуть меньшим шрифтом в редакторе и compact TaskPanel — целевой прирост ~15%.
 */
export const SIMULATOR_MOBILE_COMPACT_CLASS =
  "text-sm leading-normal antialiased" as const;
